import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1300px;
  display: flex;
  overflow-x: auto;

  flex-direction: column;

  h1 {
    text-align: left;
    margin-bottom: 15px;
    color: #000;
  }

  @media (max-width: 750px) {
    padding: 10px 0;
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 15px;
    }
  }
  .resumes {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 20px 0;
  }

  .atalho {
    width: 200px;
    height: 45px;
    border-radius: 50px;
    background-color: #f0f0f0;
    margin: 0 10px 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .resume {
    padding: 8px 16px;
    border-radius: 10px;
    background-color: #e4e4e4;
    min-width: 200px;
    margin: 0 10px 10px 0;

    h4 {
      font-size: 18px;
    }

    p {
      font-size: 12px;
    }
  }
`;
